import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from "@angular/core";
import { numberColorMap } from "./number-color-constants";

@Directive({
    selector: "[number-color]"
})
export class NumberColorDirective implements OnChanges {
    @Input() numberValue: number = 0;

    constructor(private elementRef: ElementRef) {
    }

        ngOnChanges(_changes: SimpleChanges): void {
            for (let color in numberColorMap) {
                if (numberColorMap[color].start <= this.numberValue && numberColorMap[color].end >= this.numberValue) {
                    this.elementRef.nativeElement.style.backgroundColor = color;
                    break;
                }
            }
        }
}
